import 'pixi.js/math-extras';
import {Vehicule} from "./Vehicule";

// Constructor
export class GameACar extends Vehicule {

  constructor(id, index, game, startsHidden) {
    super(id, index, game);

    this.type = "cars";

    this.speed = 1.5;
    this.bicycleMovingSpeed = -8;
    this.currentSpeed = this.speed;
    this.targetSpeed = this.speed;

    this.floatingRange = 4;
    this.scalingRange = {min: 1.7, max: 1.7}; // not working as expected so leave as same value for both

    this.rightLimit = this.game.appWidth + 300;
    this.leftLimit = -300;

    this.posYRange = {min: 180, max: 200}; // from bottom

    // distribute visible and evenly, basically this will only happen at game start
    this.spawn(false, null, true);
  }

  getRandomTexture() {
    return "car-" + window.getRandomInt(1, 3);
  }


  appear() {
    // No animationn
  }

}
